import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HiddenMenu, Menu, NavItem } from 'components'
import { userAtom } from '@/atoms/_globalAtoms'
import { useIsSuperAdmin } from '@/hooks/utility/useIsSuperAdmin'
import { useRecoilValue } from 'recoil'
import { usePerformLogout } from 'providers/Auth0'
import { apiDocsPageEntry } from '@/components/admin/ApiDocs/apiDocsPageEntry'

export const UserDropDown = () => {
  const [userOpen, setUserOpen] = useState(false)

  const dropdownItems = [
    {
      text: 'Log out',
      onClick: () => logout(),
    },
  ]

  const user = useRecoilValue(userAtom)
  const logout = usePerformLogout()
  const { t } = useTranslation()
  const isSuperAdmin = useIsSuperAdmin()

  const adminItems = isSuperAdmin
    ? [
        { text: t('dashboard.admin'), link: '/admin' },
        { text: t('dashboard.developers'), link: apiDocsPageEntry.path },
      ]
    : []

  return (
    <HiddenMenu
      left
      show={[userOpen, setUserOpen]}
      parentElement={() => (
        <NavItem
          text={user?.name}
          dropdown
          selected={userOpen}
          onClick={() => setUserOpen(!userOpen)}
          responsiveColor={true}
        />
      )}
      hiddenElement={() => (
        <Menu
          show={[userOpen, setUserOpen]}
          margin="0 24px 0 0"
          items={[...adminItems, ...dropdownItems]}
        />
      )}
    />
  )
}

export default UserDropDown
